import React from "react";
import Pagination from "./Pagination.jsx";

const FindOfficePagination = ({
  title = "Office Locations",
  currentPage = 1,
  totalPages = 1,
  onPageChange,
  isLoading = false,
  loadingMessage,
  noMatchTitle,
  noMatchMessage,
  locations = [],
  showFilters = true,
  showViews = true,
  filters = [],
  activeFilter,
  onFilterChange,
  visibleCount,
  isAgencyVerification = false,
}) => {
  const hasLocations = Array.isArray(locations) && locations.length > 0;
  const locationsCount = hasLocations ? locations.length : 0;
  const isEmpty = !isLoading && !hasLocations;
  const isNormal = !isLoading && hasLocations;
  const viewState = isLoading ? "loading" : isEmpty ? "empty" : "normal";

  const stateClass =
    viewState === "loading"
      ? "is-loading"
      : viewState === "empty"
        ? "is-empty"
        : "is-normal";

  const showPagination = isNormal && totalPages > 1;

  const countAll = locationsCount;
  const countStewart = locations.filter(
    loc => loc.AgentType !== "I",
  ).length;
  const countIndependent = locations.filter(
    loc => loc.AgentType === "I",
  ).length;

  const titleCount =
    typeof visibleCount === "number" ? visibleCount : locationsCount;

  return (
    <section
      className={`find-office-pagination ${stateClass}`}
      data-current={currentPage}
      data-total={totalPages}
      data-loading={isLoading ? "true" : "false"}
      data-empty={isEmpty ? "true" : "false"}
      data-state={viewState}
      aria-busy={isLoading ? "true" : "false"}
    >
      <h2
        className={`find-office-pagination__title ${isAgencyVerification ? "find-office-pagination__title--agency" : ""}`}
      >
        {isLoading && <span data-title-slot="loading">{loadingMessage}</span>}
        {isEmpty && <span data-title-slot="empty">{noMatchTitle}</span>}
        {isNormal && (
          <span data-title-slot="normal">
            <span className="js-locations-count">{titleCount}</span>{" "}
            {isAgencyVerification ? "Agency Locations" : "Office Locations"}
          </span>
        )}
      </h2>

      {/* ===== Loading ===== */}
      {isLoading && (
        <div
          className="find-office-pagination__loading"
          data-slot="loading"
          role="status"
          aria-live="polite"
        >
          <i className="fad fa-spinner fa-spin" aria-hidden="true"></i>
          <span className="sr-only">{loadingMessage}</span>
        </div>
      )}

      {/* ===== Empty ===== */}
      {isEmpty && (
        <div
          className="find-office-pagination__empty"
          data-slot="empty"
          aria-live="polite"
        >
          <p className="find-office-pagination__empty-subtitle">
            {noMatchMessage}
          </p>
        </div>
      )}

      {/* ===== Normal ===== */}
      {isNormal && (
        <div
          className={`${isAgencyVerification ? "agency-verification-pagination__controls" : "find-office-pagination__controls"}`}
          data-slot="normal"
        >
          {!isAgencyVerification && (
            <div className="find-office-pagination__content">
              {showFilters && Array.isArray(filters) && filters.length > 0 && (
                <div className="find-office-pagination__filters">
                  <button
                    className={`filter-btn ${activeFilter === "all" ? "active" : ""}`}
                    data-filter="all"
                    aria-label={`All (${countAll})`}
                    type="button"
                    onClick={() => onFilterChange("all")}
                  >
                    <span className="filter-btn__label">All</span>
                    <span className="filter-btn__count">({countAll})</span>
                  </button>

                  <button
                    className={`filter-btn ${activeFilter === "stewart" ? "active" : ""}`}
                    data-filter="stewart"
                    aria-label={`Stewart Offices (${countStewart})`}
                    type="button"
                    onClick={() => onFilterChange("stewart")}
                  >
                    <span className="filter-btn__label">Stewart Offices</span>
                    <span className="filter-btn__count">({countStewart})</span>
                  </button>

                  <button
                    className={`filter-btn ${activeFilter === "independent" ? "active" : ""}`}
                    data-filter="independent"
                    aria-label={`Independent Agencies (${countIndependent})`}
                    type="button"
                    onClick={() => onFilterChange("independent")}
                  >
                    <span className="filter-btn__label">
                      Independent Agencies
                    </span>
                    <span className="filter-btn__count">
                      ({countIndependent})
                    </span>
                  </button>
                </div>
              )}

              {showViews && (
                <div
                  className="find-office-pagination__views"
                  role="group"
                  aria-label="Views"
                >
                  <button
                    className="view-btn active"
                    data-view="list"
                    aria-pressed="true"
                    type="button"
                  >
                    <i className="fal fa-list" aria-hidden="true"></i>
                    <span className="sr-only">List</span>
                  </button>
                  <button
                    className="view-btn"
                    data-view="map"
                    aria-pressed="false"
                    type="button"
                  >
                    <i className="far fa-map" aria-hidden="true"></i>
                    <span className="sr-only">Map</span>
                  </button>
                </div>
              )}
            </div>
          )}

          {showPagination && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onChange={onPageChange}
            />
          )}
        </div>
      )}
    </section>
  );
};

export default FindOfficePagination;
